export default{
    async getDashboardData(){
        return await this.$axios.$get(
            this.$api.user.dashboard.getData
        )
    },
    async getNotificationDetail({}, id){
        let result = null;
        await this.$axios.$post(
            this.$api.user.dashboard.getNotificationDetail,
            {id: id}
        )
        .then(response => {
            result = response;
        })
        .catch(error => {
        })
        return result;
    }
}